import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { formatErr } from "@/lib/api";

const DEMO = [
  { label: "Admin — Martin", email: "martin@brunner.at", pw: "admin123", tint: "#1B1E23" },
  { label: "PM — Christian", email: "christian@brunner.at", pw: "pm123", tint: "#0E62C4" },
  { label: "Designer — Jonas", email: "jonas@brunner.at", pw: "designer123", tint: "#BE2E6C" },
];

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    setLoading(true); setErr("");
    try {
      await login(email, pw);
      nav("/");
    } catch (e2) {
      setErr(formatErr(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  const quick = (d) => { setEmail(d.email); setPw(d.pw); };

  return (
    <div className="min-h-screen w-full bg-paper flex">
      {/* Left brand pane */}
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-14 border-r border-line">
        <div>
          <img src="/logo-brunner.png" alt="Brunner Kundenportal" style={{maxHeight: 40}} />
        </div>
        <div className="max-w-md">
          <h1 className="font-archivo font-extrabold text-5xl leading-[1.05] mb-6">
            Ein Ort für <br/>Briefings, Zeiten <br/>und Abrechnung.
          </h1>
          <p className="text-ink/70 leading-relaxed">
            Für Projektmanager und externe Designer. Klar strukturiert, in Deutsch, ohne Ballast.
          </p>
        </div>
        <div className="mono-label">© Brunner Werbeagentur</div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <h2 className="font-archivo font-bold text-2xl mb-1">Anmelden</h2>
          <div className="mono-label mb-8">Zugang nur per Einladung</div>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="mono-label block mb-1.5">E-Mail</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-3 py-2.5 bg-white border border-line rounded-sm text-ink focus:outline-none focus:border-ink"
                placeholder="name@brunner.at"
              />
            </div>
            <div>
              <label className="mono-label block mb-1.5">Passwort</label>
              <input
                data-testid="login-password"
                type="password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                required
                className="w-full px-3 py-2.5 bg-white border border-line rounded-sm text-ink focus:outline-none focus:border-ink"
              />
            </div>

            {err && <div data-testid="login-error" className="text-sm px-3 py-2 rounded-sm bg-brunnerMagenta/10 text-brunnerMagenta border border-brunnerMagenta/30">{err}</div>}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full py-2.5 bg-ink text-white rounded-sm font-medium hover:bg-black transition-colors disabled:opacity-60"
            >
              {loading ? "Anmelden…" : "Anmelden"}
            </button>
          </form>

          <div className="mt-10 pt-6 border-t border-line">
            <div className="mono-label mb-3">Demo-Zugänge</div>
            <div className="space-y-2">
              {DEMO.map((d) => (
                <button
                  key={d.email}
                  onClick={() => quick(d)}
                  data-testid={`demo-${d.email.split("@")[0]}`}
                  className="w-full flex items-center justify-between px-3 py-2 border border-line rounded-sm bg-white hover:border-ink transition-colors text-left"
                >
                  <span className="text-sm font-medium">{d.label}</span>
                  <span className="mono-label" style={{ color: d.tint, opacity: 1 }}>{d.email}</span>
                </button>
              ))}
            </div>
            <div className="mono-label mt-3 opacity-60">Passwörter: admin123 · pm123 · designer123</div>
          </div>
        </div>
      </div>
    </div>
  );
}
